//CONSTANT
import { GET_APP_NAME_FOR_COLLECTION } from "../../app_constant";
import { getTodayLocal, getYesterdayLocal, getLocalDateString } from "../utils/dates";

//PACKAGES
import { firestore, auth } from "./config";
import { getEffectiveUid } from "./ghostUid";

async function GET_QUESTION_OF_THE_DAY() {
  try {
      const APP_NAME = await GET_APP_NAME_FOR_COLLECTION()
      const today = getTodayLocal();
      const result = await firestore().collection('apps').doc(APP_NAME).collection('qotd').doc(today).get()
      console.log('GET_QUESTION_OF_THE_DAY', result.exists, result.data())
      if (result.exists) {
          return { status: true, data: result.data(), error: '', isExist: true }
      }
      else {
          return { status: true, data: null, error: '', isExist: false }
      }
  }
  catch (error) {
      console.log('error', error)
  }
}

async function GET_QOTD_BY_DATE(date) {
  try {
      const APP_NAME = await GET_APP_NAME_FOR_COLLECTION()
      const result = await firestore().collection('apps').doc(APP_NAME).collection('qotd').doc(date).get()
      console.log('GET_QOTD_BY_DATE', date, result.exists, result.data())
      if (result.exists) {
          return { status: true, data: result.data(), error: '', isExist: true }
      }
      else {
          return { status: true, data: null, error: '', isExist: false }
      }
  }
  catch (error) {
      console.log('GET_QOTD_BY_DATE error', error)
      return { status: false, data: null, error: error.message }
  }
}

async function UPDATE_QUESTION_OF_THE_DAY(id, questionsList = null) {
  try {
      const APP_NAME = await GET_APP_NAME_FOR_COLLECTION()
      const today = getTodayLocal();
      
      // First, check if we need to seed QOTD history for the last 30 days
      if (questionsList && questionsList.length > 0) {
        await seedQOTDHistoryIfNeeded(APP_NAME, questionsList);
      }
      
      // Update today's question
      await firestore().collection('apps').doc(APP_NAME).collection('qotd').doc(today).set({
          question_id: id,
          date: today
      })
      return { status: true, data: null, error: '' }
  }
  catch (error) {
      console.log('UPDATE_QUESTION_OF_THE_DAY error', error)
      return { status: false, error: error.message }
  }
}

// Helper function to seed QOTD history if needed
async function seedQOTDHistoryIfNeeded(APP_NAME, questionsList) {
  try {
    // Check if we already have QOTD data for the last 30 days
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const thirtyDaysAgoStr = getLocalDateString(thirtyDaysAgo);
    
    // Get existing QOTD data for the last 30 days
    const existingQOTDs = await firestore()
      .collection('apps')
      .doc(APP_NAME)
      .collection('qotd')
      .where('date', '>=', thirtyDaysAgoStr)
      .get();
    
    // If we have less than 30 days of data, seed the missing days
    if (existingQOTDs.docs.length < 30) {
      console.log(`Seeding QOTD history. Found ${existingQOTDs.docs.length} existing entries, need 30.`);
      
      const existingDates = new Set();
      existingQOTDs.docs.forEach(doc => {
        if (doc.data().date) {
          existingDates.add(doc.data().date);
        }
      });
      
      // Generate dates for the last 30 days using local timezone
      const datesToSeed = [];
      for (let i = 29; i >= 0; i--) {
        const date = new Date();
        date.setDate(date.getDate() - i);
        const dateStr = getLocalDateString(date);
        
        if (!existingDates.has(dateStr)) {
          datesToSeed.push(dateStr);
        }
      }
      
      // Seed missing dates with random questions
      if (datesToSeed.length > 0) {
        const batch = firestore().batch();
        
        datesToSeed.forEach((dateStr, index) => {
          // Use a deterministic but varied selection to avoid same question on consecutive days
          const questionIndex = (index * 7 + Math.floor(index / 3)) % questionsList.length;
          const selectedQuestion = questionsList[questionIndex];
          
          const qotdRef = firestore()
            .collection('apps')
            .doc(APP_NAME)
            .collection('qotd')
            .doc(dateStr);
          
          // Generate random performance data for seeded QOTD
          const totalAnswered = Math.floor(Math.random() * 50) + 10; // Random number between 10-59
          const correctAnswers = Math.floor(Math.random() * totalAnswered); // Random number less than total_answered
          
          batch.set(qotdRef, {
            question_id: selectedQuestion.id,
            date: dateStr,
            seeded: true, // Flag to indicate this was seeded data
            seeded_at: new Date().toISOString(),
            total_answered: totalAnswered,
            correct_answers: correctAnswers
          });
        });
        
        await batch.commit();
        console.log(`Successfully seeded ${datesToSeed.length} QOTD entries`);
      }
    }
  } catch (error) {
    console.error('Error seeding QOTD history:', error);
    // Don't throw error - seeding failure shouldn't prevent QOTD creation
  }
}

async function GET_QOTD_STATISTICS(date = null) {
  try {
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    const targetDate = date || getTodayLocal();
    const result = await firestore().collection('apps').doc(APP_NAME).collection('qotd').doc(targetDate).get()
    return { status: true, data: result.data(), error: '' }
  }
  catch (error) {
    console.log('GET_QOTD_STATISTICS error', error)
  }
}

// Helper function to get user QOTD collection reference
const getUserQOTDCollection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore()
    .collection("apps")
    .doc(APP_NAME)
    .collection("users")   
    .doc(getEffectiveUid())
    .collection("qotd");
};

async function UPDATE_USER_QOTD(qotdResult) {
  console.log('>>>>>>>>>>>>>>>>>>>>>>>> Calling UPDATE_USER_QOTD', qotdResult);
  try {
    const today = getTodayLocal();
    const yesterday = getYesterdayLocal();
    
    const qotdCollection = await getUserQOTDCollection();
    
    // Save today's QOTD response as a separate document
    await qotdCollection.doc(today).set({
      date: today,
      isCorrect: qotdResult.isCorrect,
      timeSpent: qotdResult.timeSpent || 0,
      answered_at: new Date().toISOString(),
      ...qotdResult // Include any additional data
    });
    
    // Get or create summary document
    const summaryDoc = await qotdCollection.doc("summary").get();
    const currentSummary = summaryDoc.exists ? summaryDoc.data() : {
      current_streak: 0,
      best_streak: 0,
      total_answered: 0,
      total_correct: 0,
      last_qotd_date: null
    };
    
    // Check if user answered yesterday to calculate streak
    const yesterdayDoc = await qotdCollection.doc(yesterday).get();
    const answeredYesterday = yesterdayDoc.exists;
    
    let newStreak;
    if (answeredYesterday) {
      newStreak = currentSummary.current_streak + 1;
    } else {
      newStreak = 1; // Reset streak to 1 as they answered today
    }
    
    // Update best streak if current streak is greater
    const newBestStreak = Math.max(currentSummary.best_streak, newStreak);
    
    // Update summary
    const newSummary = {
      current_streak: newStreak,
      best_streak: newBestStreak,
      total_answered: currentSummary.total_answered + 1,
      total_correct: currentSummary.total_correct + (qotdResult.isCorrect ? 1 : 0),
      last_qotd_date: today
    };
    
    await qotdCollection.doc("summary").set(newSummary);
    
    // Update global qotd statistics
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    const questionOfDayRef = firestore()
      .collection('apps')
      .doc(APP_NAME)
      .collection('qotd')
      .doc(today);
    
    // Use atomic operations to update statistics
    await questionOfDayRef.update({
      total_answered: firestore.FieldValue.increment(1),
      correct_answers: firestore.FieldValue.increment(qotdResult.isCorrect ? 1 : 0)
    });
    
    console.log('>>>>>>>>>>>>>>>>>>>>>>>> UPDATE_USER_QOTD completed', newSummary);
    return { status: true, error: "" };
  } catch (error) {
    console.log('>>>>>>>>>>>>>>>>>>>>>>>> Error in UPDATE_USER_QOTD', error);
    return { status: false, error: error.message };
  }
}

// Function to get QOTD history for the last 30 days
async function GET_QOTD_HISTORY() {
  try {
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    
    // Get QOTD data for the last 30 days using local timezone
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
    const thirtyDaysAgoStr = getLocalDateString(thirtyDaysAgo);
    
    const result = await firestore()
      .collection('apps')
      .doc(APP_NAME)
      .collection('qotd')
      .where('date', '>=', thirtyDaysAgoStr)
      .orderBy('date', 'desc')
      .get();
    
    const history = [];
    result.docs.forEach(doc => {
      const data = doc.data();
      history.push({
        date: data.date,
        question_id: data.question_id,
        seeded: data.seeded || false,
        total_answered: data.total_answered || 0,
        correct_answers: data.correct_answers || 0
      });
    });
    
    return { status: true, data: history, error: '' };
  } catch (error) {
    console.error('GET_QOTD_HISTORY error:', error);
    return { status: false, data: [], error: error.message };
  }
}

// Function to get user's QOTD summary
async function GET_USER_QOTD_SUMMARY() {
  try {
    const qotdCollection = await getUserQOTDCollection();
    const summaryDoc = await qotdCollection.doc("summary").get();
    
    const summary = summaryDoc.exists ? summaryDoc.data() : {
      current_streak: 0,
      best_streak: 0,
      total_answered: 0,
      total_correct: 0,
      last_qotd_date: null
    };
    
    return { status: true, data: summary, error: '' };
  } catch (error) {
    console.error('GET_USER_QOTD_SUMMARY error:', error);
    return { status: false, data: null, error: error.message };
  }
}

// Function to get user's QOTD response for a specific date
async function GET_USER_QOTD_RESPONSE(date) {
  try {
    const qotdCollection = await getUserQOTDCollection();
    const responseDoc = await qotdCollection.doc(date).get();
    
    if (responseDoc.exists) {
      return { status: true, data: responseDoc.data(), error: '' };
    } else {
      return { status: true, data: null, error: '', exists: false };
    }
  } catch (error) {
    console.error('GET_USER_QOTD_RESPONSE error:', error);
    return { status: false, data: null, error: error.message };
  }
}

// Function to get user's QOTD responses for a date range
async function GET_USER_QOTD_RESPONSES(startDate, endDate) {
  try {
    const qotdCollection = await getUserQOTDCollection();
    
    const result = await qotdCollection
      .where('date', '>=', startDate)
      .where('date', '<=', endDate)
      .orderBy('date', 'desc')
      .get();
    
    const responses = [];
    result.docs.forEach(doc => {
      responses.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    return { status: true, data: responses, error: '' };
  } catch (error) {
    console.error('GET_USER_QOTD_RESPONSES error:', error);
    return { status: false, data: [], error: error.message };
  }
}

// Function to get and update the current QOTD streak (legacy function for backward compatibility)
async function getStreak(profile = {}) {
  try {
    const summary = await GET_USER_QOTD_SUMMARY();
    if (summary.status) {
      return summary.data.current_streak;
    }
    return 0;
  } catch (error) {
    console.error('getStreak error:', error);
    return 0;
  }
}

export {
  GET_QUESTION_OF_THE_DAY,
  GET_QOTD_BY_DATE,
  UPDATE_QUESTION_OF_THE_DAY,
  UPDATE_USER_QOTD,
  GET_QOTD_STATISTICS,
  GET_QOTD_HISTORY,
  GET_USER_QOTD_SUMMARY,
  GET_USER_QOTD_RESPONSE,
  GET_USER_QOTD_RESPONSES,
  getStreak
};
